<template>
  <div>
    <div
      class="kqf-card mg10 pd10 pt30 mt30"
      v-loading="loading"
      style="display: flex"
    >
      <el-form ref="form" :model="form" style="width: 100%">
        <el-table-column label="操作">
          <div class="flex">
            <el-form-item
              label="标题："
              label-width="100px"
              style="width: 40%"
              required
            >
              <el-input
                v-model="form.title"
                placeholder="新闻标题，同SEO标题"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="摘要："
              label-width="100px"
              style="width: 40%; margin-left: 5%"
              required
            >
              <el-input
                v-model="form.abstract"
                placeholder="新闻摘要"
              ></el-input>
            </el-form-item>
          </div>
        </el-table-column>
        <div class="flex">
          <el-form-item label="关键字：" label-width="100px" style="width: 40%">
            <el-input
              v-model="form.keywords"
              placeholder="SEO 关键字"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="描述："
            label-width="100px"
            style="width: 40%; margin-left: 5%"
          >
            <el-input
              v-model="form.description"
              placeholder="SEO 描述"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="分类：" label-width="100px" style="width: 40%">
            <select-article-cat v-model="form.category_id"></select-article-cat>
          </el-form-item>
          <el-form-item
            label="排序："
            label-width="100px"
            style="width: 40%; margin-left: 5%"
            required
          >
            <el-input-number v-model="form.sort" :min="0"></el-input-number>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item
            label="推荐："
            label-width="100px"
            style="width: 40%"
            required
          >
            <el-switch
              v-model="form.recommend"
              :active-value="2"
              :inactive-value="1"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="启用："
            label-width="100px"
            style="width: 40%; margin-left: 5%"
            required
          >
            <el-switch
              v-model="form.status"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
          </el-form-item>
          <el-form-item label="微信专属：" label-width="100px" required>
            <el-switch v-model="form.exclusive" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
        </div>
        <el-form-item
          label="图片："
          label-width="100px"
          style="width: 40%"
          required
        >
          <upload-one w="80px" h="80px" v-model="form.image"></upload-one>
          <!-- <p class="form-tip">建议尺寸 154 * 120 或等比例缩放</p> -->
        </el-form-item>
        <el-form-item label="内容：" label-width="100px" required>
          <html-editor v-model="form.content" type="pc"></html-editor>
        </el-form-item>
        <div mt30 style="text-align: center">
          <div>
            <el-button
              icon="el-icon-arrow-left"
              @click="toList"
              type="text"
              style="margin-right: 30px"
              >返回列表</el-button
            >
            <el-button
              icon="el-icon-check"
              type="primary"
              @click="createArticle"
              size="medium"
              >提交保存</el-button
            >
          </div>
        </div>
      </el-form>
    </div>

    <!-- <div class="tdkp-toolbar">
            <div>
                <el-button icon="el-icon-arrow-left" @click="toList" type="text" style="margin-right: 30px">返回列表</el-button>
                <el-button icon="el-icon-check"  type="primary" @click="createArticle">提交保存</el-button>
            </div>
        </div> -->
  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
import HtmlEditor from "../../components/editer/Editer";
import { createArticle } from "../../request/api/article/article";
import SelectArticleCat from "./components/SelectArticleCat";
export default {
  components: { SelectArticleCat, UploadOne, HtmlEditor },
  data() {
    return {
      loading: false,
      category_names: [],
      form: {
        title: "",
        keywords: "",
        abstract: "",
        description: "",
        category_id: 1,
        image: "",
        content: "",
        recommend: "1",
        introduction_video: "",
        detailed_video: "",
        sort: "0",
        status: "1",
        exclusive:"0",
      },
    };
  },
  created() {},
  methods: {
    toList() {
      this.$router.push("/article/index");
    },
    createArticle() {
      this.loading = true;
      createArticle({
        title: this.form.title,
        category_id: this.form.category_id,
        description: this.form.description,
        keywords: this.form.keywords,
        image: this.form.image,
        content: this.form.content,
        abstract: this.form.abstract,
        recommend: this.form.recommend,
        introduction_video: this.form.introduction_video,
        detailed_video: this.form.detailed_video,
        sort: this.form.sort,
        status: this.form.status,
        exclusive: this.form.exclusive,
      })
        .then(() => {
          this.loading = false;
          this.$message.success("操作成功");
          setTimeout(() => {
            this.toList();
          }, 500);
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleChange(category_name) {
      this.form.category_id = category_name[1] || category_name[0];
    },
  },
};
</script>
<style scoped>
</style>